'use-strict';

/* @ngInject */
export default function WorkflowTableController(
  $scope,
  $location,
  monitoringApiService,
  interfaceService,
  NgTableParams,
) {
  const self = this;
  $scope.rules = null;

  const updateTableData = (data) => {
    self.ruleTable.settings({
      dataset: data,
    });
    interfaceService.applyScope($scope);
  };

  /**
   * Change route to rule form.
   * @param {number} ruleId
   */
  $scope.ruleClick = (ruleId) => {
    $location.path(`/workflows/edit/${ruleId}`);
  };

  /**
   * Remove all applied filters from table
   */
  $scope.removeAllFilter = () => {
    self.ruleTable.filter({});
    $scope.filteredTableData = $scope.cars;
  };

  /**
   * Remove the supplied filter from the view's table.
   * @param {Object} filter
   */
  $scope.removeFilter = (filter) => {
    delete self.ruleTable.filter()[filter];
  };

  const getEventRules = () => {
    monitoringApiService.apiGetEventRules()
      .then((rules) => {
        $scope.rules = rules;
        updateTableData(rules);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const init = () => {
    getEventRules();
    self.ruleTable = new NgTableParams();
  };

  init();
}
